
import PropTypes from 'prop-types'
import React from 'react'
import './index.css'
import Alert from 'ui/Alert'

const SetupError = props => (
  <div className='SetupError'>
    <Alert type='danger' noIcon>
      <div className='SetupError-content'>
        <h4>{props.title}</h4>

        <div className='SetupError-message'>
          {props.message}
        </div>

        <div className='SetupError-children'>
          {props.children}
        </div>
      </div>
    </Alert>
  </div>
)

SetupError.displayName = 'SetupError'

SetupError.propTypes = {
  children: PropTypes.array.isRequired,
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export default SetupError



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/components/setup-error/index.js